/*
    Description: data page frontend actions
    Author URI: https://destinationsalesandmarketinggroup.com/
    Author: adillice
    Version: 1.0.0
*/

// Data class
class Data{

    // constructor
    constructor({
        
        // set default selector
        selector = ".data__topics__copy ul li:nth-child(odd)",
        accordionSelector = "--data-topics-expanded",
        showClass = "--data-show-li"

    } = {}){

        // get DOM element
        this.dataSelector = (selector) ? document.querySelectorAll(selector) : null;

        // accordion selector
        this.accordionSelector = accordionSelector;

        // show li class
        this.showLI = showClass;

        // fire off events - only if we have dataSelector
        if(this.dataSelector) this.events();

    }

    // fire off all events
    events(){

        // add event listner to li
        this.dataSelector.forEach(item => {
            
            item.addEventListener("click", this.expandLI.bind(this));

        });

    }

    // accordion li on click event
    expandLI(e){

        // get clicked li and is next sibling
        const thisLI = e.target, 
        nextLI = thisLI.nextElementSibling;
        
        // animate arrow
        thisLI.classList.toggle(this.accordionSelector);
        
        // display sibling li
        (nextLI && nextLI.classList) ? nextLI.classList.toggle(this.showLI) : nextLI.classList.add(this.showClass);

    }

}

// export data
export default Data;